import cn from "class-names"
import styles from "@components/Listings/ListingsFilter/ListingsFilter.module.scss"
import compStyles from "@css/Components.module.scss"
import Nouislider from "nouislider-react"
import { rangeMaxValues } from "@components/Listings/ListingsFilter/const"
import React, { useDeferredValue, useEffect, useMemo, useRef, useState } from "react"
import { addCurrency } from "@utils/index"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"
import { ElWithSliderApi } from "@components/Listings/ListingsFilter/components/fields/types"

function formatTooltip(max: number) {
    return (val: number) => {
        return val > max ? "Max" : addCurrency(val)
    }
}

const from = (val: number) => val

const ppStatic = {
    connect: [true, false],
    tooltips: [{ to: formatTooltip(300), from }],
    range: {
        min: 50,
        max: 305
    }
}

export function PricePerPoint() {
    const value = useFilterStore((s) => s.price_per_point_lte)
    const onRangeChange = useFilterStore((s) => s.onRangeChange)
    const defRef = useRef(value)
    const [el, setEl] = useState<ElWithSliderApi>(null)
    const deferredValue = useDeferredValue(value)
    useEffect(() => {
        if (el) {
            el.noUiSlider.set(deferredValue, false, true)
        }
    }, [deferredValue, el])
    const onChange = useMemo(() => onRangeChange("price_per_point", rangeMaxValues.price_per_point), [onRangeChange])
    return (
        <div className={cn(compStyles.sliderWrapper, styles.filterItem)}>
            <span className={styles.itemTitle}>Max Price Per Point</span>
            <div className={compStyles.sliderSkeleton} style={{ display: el ? "none" : "block" }} />

            <Nouislider instanceRef={setEl as any} onChange={onChange} start={defRef.current} behaviour={"tap-drag"} step={5} {...ppStatic} />
        </div>
    )
}
